/*
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 */

jQuery(document).ready(function($) {

	var stickyHeaderWidth = 1200,
		stickyHeaderStart = 200,
		headerOffset      = 80,
		menuResizeWidth   = 767;

	//--------------------------------------------
	// Menus
	//--------------------------------------------

	$('#header-a #main-menu, #header-b #main-menu, #header-d #main-menu').argonmenu({

		resizeWidth: menuResizeWidth,
		collapserTitle: '',
		animSpeed: 'medium',
		easingEffect: null,
		indentChildren: false,
		childrenIndenter: '&nbsp;',
		expandIcon: '<span class="sub-collapser"><i class="fa fa-angle-down"></i></span>',
		collapseIcon: '<span class="sub-collapser"><i class="fa fa-angle-up"></i></span>'

	});

	$('#main-menu a[href="#"]').click(function(){

		if ($(window).width() <= menuResizeWidth) {

			$(this).parent().find('> .sub-toggle').click();

		}

		return false;

	});

	$('#header-c .nav-icon').click(function(){

		$('body').toggleClass('nav-open');

	});

	//--------------------------------------------
	// Sticky Header
	//--------------------------------------------

	var stickyHeader = $('#header-a, #header-b, #header-c, #header-d');

	function rpjcStickyHeader() {

		var screenSize = $(window).width(),
			scrollTop  = $(document).scrollTop(),
			wrapper    = $('#wrapper');

		if (screenSize < stickyHeaderWidth ) return;

		if ( scrollTop > stickyHeaderStart ) {

			$(stickyHeader).addClass('stuck');
			$(wrapper).addClass('header-stuck');

		} else {

			$(stickyHeader).removeClass('stuck');
			$(wrapper).removeClass('header-stuck');

		}

	}

	rpjcStickyHeader();

	$(window).scroll(rpjcStickyHeader);

	//--------------------------------------------
	// Site Search
	//--------------------------------------------

	$('.toggle-search').click(function() {

		$('body').toggleClass('search-open');

		$('.site-search input[type="text"]').focus();

		return false;

	});

	$('.site-search-close').click(function() {

		$('body').toggleClass('search-open');

		return false;

	});

	//--------------------------------------------
	// Sliders
	//--------------------------------------------

	if ($('.default-slider').length) {

		var defaultSlider = tns({

			container: '.default-slider .slider',
			items: 1,
			autoplay: true,
			autoplayTimeout: 5000,
			speed: 400,
			loop: true,
			nav: false,
			autoplayButtonOutput: false,
			mouseDrag: true,
			controlsText: ['<i class="icon-arrows-left"></i>', '<i class="icon-arrows-right"></i>']

		});

	}

	if ($('.logo-scroller').length) {

		var logoScroller = tns({

			container: '.logo-scroller .slider',
			items: 2,
			autoplay: true,
			autoplayTimeout: 2500,
			speed: 400,
			gutter: 20,
			edgePadding: -10,
			loop: true,
			nav: false,
			controls: false,
			autoplayButtonOutput: false,
			responsive: {
				480: {
					items: 3
				},
				768: {
					items: 5
				}
			}

		});

	}

	if ($('#landing.has-slider').length) {

		var landingSlider = tns({

			container: '#landing.has-slider .slider',
			mode: 'gallery',
			items: 1,
			autoplay: true,
			autoplayTimeout: 5000,
			speed: 400,
			loop: true,
			nav: false,
			autoplayButtonOutput: false

		});

	}

	if ($('.testimonial-slider').length) {

		var testimonialSlider = tns({

			container: '.testimonial-slider .slider',
			mode: 'gallery',
			items: 1,
			autoplay: true,
			autoplayTimeout: 5000,
			speed: 400,
			loop: true,
			nav: true,
			navPosition: 'bottom',
			autoplayButtonOutput: false,
			controls: false

		});

	}

	if ($('.section-slider').length) {

		var sectionSlider = tns({

			container: '.section-slider .slider',
			items: 1,
			autoplay: true,
			autoplayTimeout: 5000,
			speed: 400,
			loop: true,
			nav: true,
			controls: false

		});

	}

	//--------------------------------------------
	// Lightbox
	//--------------------------------------------

	$('.lightbox-image').magnificPopup({
		closeBtnInside: false,
		mainClass: 'rpjc-magnific',
		closeMarkup: '<div title="%title%" class="mfp-close"><span></span><span></span></div>',
		type: 'image'
	});

	$('.lightbox-image.wp-block-image').magnificPopup({
		delegate: 'a',
		closeBtnInside: false,
		mainClass: 'rpjc-magnific',
		closeMarkup: '<div title="%title%" class="mfp-close"><span></span><span></span></div>',
		type: 'image'
	});

	$('.lightbox-iframe').magnificPopup({
		closeBtnInside: false,
		mainClass: 'rpjc-magnific',
		closeMarkup: '<div title="%title%" class="mfp-close"><span></span><span></span></div>',
		type: 'iframe'
	});

	$('.lightbox-team').magnificPopup({
		closeBtnInside: false,
		mainClass: 'rpjc-magnific rpjc-magnific-team',
		closeMarkup: '<div title="%title%" class="mfp-close"><span></span><span></span></div>',
		type: 'ajax',
		fixedContentPos: true,
		callbacks: {
			ajaxContentAdded: function() {
				$('.close-team-lightbox').click(function(){
					$.magnificPopup.close();
				});
			}
		}
	});

	$('.gallery-item').magnificPopup({
		delegate: 'a',
		closeBtnInside: false,
		mainClass: 'rpjc-magnific',
		closeMarkup: '<div title="%title%" class="mfp-close"><span></span><span></span></div>',
		type: 'image',
		closeOnBgClick: false,
		gallery: {
			enabled: true,
			arrowMarkup: '<div title="%title%" class="mfp-arrow mfp-arrow-%dir%"><span></span><span></span></div>'
		}
	});

	//--------------------------------------------
	// Accordion
	//--------------------------------------------

	$('.accordion .accordion-content').hide();

	var hash = window.location.hash;

	// check if there's hash tag in the URL
	if (hash.length) {

		var selectedAccordionItem = $('body').find('.accordion .accordion-item' + hash);

		// if yes, open the matching accordion item
		if (selectedAccordionItem.length) {

			selectedAccordionItem.addClass('selected').find('.accordion-content').show();

			// perform scroll down but add in 140 padding for the sticky header
			$('html, body').animate({scrollTop: selectedAccordionItem.offset().top - 140},'slow');

		}

	}

	$('.accordion-handle').click(function(){

		var accordion = $(this).parent().parent();

		if ($('.accordion-content').not(':animated')) {

			if ($(this).parent().hasClass('selected')) {

				$(this).next().slideUp(300).end().parent().removeClass('selected');

			} else {

				$(accordion).find('.accordion-item').removeClass('selected');
				$(this).parent().addClass('selected');
				$(accordion).find('.accordion-content').slideUp(300);
				$(this).next().slideDown(300);

			}

		}

		return false;

	});

	//--------------------------------------------
	// Tabs
	//--------------------------------------------

	$('.tabbed-content .tab-nav li:first-child').addClass('active');
	$('.tabbed-content .tab-window .tab-panel').not(':first-child').hide();

	$('.tabbed-content .tab-nav a').click(function(){

		var target = $(this).attr('href');

		$(this).parent().addClass('active').siblings().removeClass('active');

		$(target).show().siblings().hide();

		return false;

	});

	//--------------------------------------------
	// Scrolling
	//--------------------------------------------

	// Scroll to element

	$('.scroll-to').click(function(){

		var selected = $(this).attr('href'),
			scrollPx = ($(window).width() < stickyHeaderWidth) ? $(selected).offset().top - 20 : $(selected).offset().top - headerOffset;

		$('html, body').animate({scrollTop: scrollPx},'slow');

		return false;

	});

	// Scroll to top link

	$('a[href="#top"]').click(function(){

		$('html, body').animate({scrollTop:0}, 'slow');

		return false;

	});

	$('.scroll-down, .scrolldown').click(function(){

		var target = $(this).parent().next(),
			distance;

		if ($(window).width() < 960) {

			distance = $(target).offset().top - 60;

		} else {

			distance = $(target).offset().top - 105;

		}

		$('html, body').animate({scrollTop: distance},'slow');

		return false;

	});

    //--------------------------------------------
	// Responsive Horizontal Scrolling
	//--------------------------------------------

	$( '.responsive-scroll' ).each( function() {

		var element       = $( this ),
			scrollWrapper = $( '<div />', {

				'class' : 'scrollable',
				'html'  : '<div class="scrollable-inner" />'

			} ).insertBefore( element );

		element.data( 'scrollWrapper', scrollWrapper );
		element.appendTo( scrollWrapper.find( 'div' ) );

		if ( element.outerWidth() > element.parent().outerWidth() ) {

			element.data( 'scrollWrapper' ).addClass( 'has-scroll' );

		}

		$( window ).on( 'resize orientationchange', function() {

			if ( element.outerWidth() > element.parent().outerWidth() ) {

				element.data( 'scrollWrapper' ).addClass( 'has-scroll' );

			} else {

				element.data( 'scrollWrapper' ).removeClass( 'has-scroll' );

			}

		} );

	} );

	//--------------------------------------------
	// fitVids
	//--------------------------------------------

	$('.main').fitVids();

	//--------------------------------------------
	// Team B
	//--------------------------------------------

	$( '.team-b .team-link' ).click( function( e ) {

		e.preventDefault();

		var details = $( this ).attr( 'href' ),
			link    = $( this );

		if ( $( link ).hasClass( 'active' ) ) {

			$( details ).hide( 0, function() {

				$( link ).removeClass( 'active' );

			});

		} else {

			$( '.person-details' ).not( details ).hide( 0, function() {

				$( '.team-b .team-link' ).not( link ).removeClass( 'active' );

			} );

			$( link ).addClass( 'active' );

			$( details ).show( 0 );

		}

	} );

	$( '.person-details .close' ).click( function() {

		var parentID = $( this ).parent().attr( 'id' );

		$( this ).parent().hide( 0, function() {

			$( 'a[href="#' + parentID + '"]' ).removeClass( 'active' );

		} );

	} );

	function rpjc_people_layout() {

		if ( $( window ).width() >= 768 ) {

			$( '.person-details' ).each( function() {

				$( this ).appendTo( $( this ).parent( '.row' ) );

			} );

		} else {

			$( '.person-details' ).each( function() {

				var thisID = $( this ).attr( 'id' );

				$( this ).insertAfter( $('a[href="#' + thisID + '"]').parent() );

			} );

		}

	}

	$( window ).on( 'load resize orientationchange', rpjc_people_layout );

});
